import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import classnames from "classnames";
import '../../../i18/config';
import {useTranslation} from "react-i18next";
import {useHistory, useRedux, useSearchInput} from "../../../hooks";

import { PlanOrderType} from "../../../redux/Sale/PlanOrder/types";
import Loader from "../../../components/Loader"
import * as route from "../../../api/routes";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import {PAGINATION_DEFAULT_ITEMS_PER_PAGE} from "../../../data/settings";
import PlanOrderColumns from "./tableColumns";
import {EntityActionsHandlersType} from "../../../redux/types";
import TableList from "../../../components/TableList";
import {setHistoryHash as setHistoryHashFunc} from "../../../helpers/functions";
import MainListFilter from "../../../components/MainListFilter";
import {getPlanOrders} from "../../../redux/Sale/PlanOrder/actions";

const PlanOrderIndex = () => {

    const { t } = useTranslation(['common']);
    const { dispatch, useAppSelector } = useRedux();

    const componentType = 'planOrderItemsType';
    const finalOrderTab = 'finalOrderTab';
    const cancelledOrderTab = 'cancelledOrderTab';

    const {
        historyHash,
        searchPhrase,
        loadItems,
        handleSearchClick
    } = useHistory({
        componentType,
        loadAction: getPlanOrders,
        dispatch
    });

    const { onSearchInput } = useSearchInput(handleSearchClick);

    const [activeTab, setActiveTab] = useState("All");

    const {
        planOrder,
        isFetched
    } = useAppSelector(state => ({
        isFetched: state.PlanOrder.isFetched,
        planOrder: state.PlanOrder,
    }));

    const [orders, setOrders] = useState<PlanOrderType[]>([]);

    useEffect(() => {
        if ((planOrder.items !== undefined) && (planOrder.items.length>0)){
            setOrders([...planOrder.items]);
        } else {
            setOrders([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [planOrder?.items])

    const toggleClickTab = (tab) => {
        if (activeTab !== tab) {
            if ( historyHash.tab !== tab) {
                historyHash.tab = tab;
                historyHash.page = 1;
                setActiveTab(tab);
                setHistoryHashFunc(historyHash);
            }
        }
    }

    const onTableRowClick = (item:PlanOrderType) => {
        window.location.href = route.PLAN_ORDER_DETAIL.replace(/:uuid/g, item.uuid);
    }

    const EntityActionsHandlers:EntityActionsHandlersType = {
        onDetail: onTableRowClick
    }

    const columns = PlanOrderColumns(EntityActionsHandlers);

    return (
        <>
            <BreadCrumb title={t('menu:orders')} pageTitle={t('menu:main')} />

            <Row>
                <Col lg={12}>
                    <Card id="orderList">
                        <CardHeader className="card-header border-0">
                            <Row className="align-items-center gy-3">
                                <div className="col-sm">
                                    <h5 className="card-title mb-0">{t('sale:ordersHistory')}</h5>
                                </div>
                                <div className="col-sm-auto">
                                    <div className="d-flex gap-1 flex-wrap">

                                    </div>
                                </div>
                            </Row>
                        </CardHeader>
                        <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">
                            <MainListFilter
                                onClick={handleSearchClick}
                                value={searchPhrase}
                                onChange={onSearchInput}
                            />
                        </CardBody>
                    <CardBody className="pt-0">
                        <div>
                            <Nav
                                className="nav-tabs nav-tabs-custom nav-success"
                                role="tablist"
                            >
                                <NavItem>
                                    <NavLink
                                        className={classnames(
                                            { active: activeTab === "All" },
                                            "fw-semibold"
                                        )}
                                        onClick={() => {
                                            toggleClickTab( "All");
                                        }}
                                        href="#"
                                    >
                                        <i className="ri-store-2-fill me-1 align-bottom font-weight-normal"></i>{" "}
                                        {t('sale:allOrders')}
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames(
                                            { active: activeTab === finalOrderTab },
                                            "fw-semibold"
                                        )}
                                        onClick={() => {
                                            toggleClickTab(finalOrderTab);
                                        }}
                                        href="#"
                                    >
                                        <i className="ri-checkbox-circle-line me-1 align-bottom font-weight-normal"></i>{" "}
                                        {t('sale:paidOrders')}
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames(
                                            { active: activeTab === cancelledOrderTab },
                                            "fw-semibold"
                                        )}
                                        onClick={() => {
                                            toggleClickTab(cancelledOrderTab);
                                        }}
                                        href="#"
                                    >
                                        <i className="ri-close-circle-line me-1 align-bottom font-weight-normal"></i>{" "}
                                        {t('sale:cancelledOrders')}
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            {isFetched ?
                                    <TableList
                                        columns={columns}
                                        data={orders || []}
                                        onRowClick={onTableRowClick}
                                        key={componentType}
                                        historyHash = {historyHash}
                                        paginationTotalRows={planOrder?.meta?.totalCount || 0}
                                        paginationServer={true}
                                        isShowChangePageSize={true}
                                    />
                                :
                                <Loader />
                            }
                        </div>
                    </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default PlanOrderIndex;


